<template>
  <div class="container pt-0">
    <div class="columns">
      <div class="column is-3">
        <generic-dropdown
          :title="$t('period')"
          :placeholder="$t('period')"
          url="/student/period/catalog"
          name_field="name"
          value_field="period_id"
          @selected="set_period"
          ref="period_dropdown"
          :is_multiple="false"
          class="mb-3"
        />
        <aside class="menu">
          <p class="menu-label">{{ $t("select group") }}</p>
          <div class="field">
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="search_group"
                :placeholder="$t('filter')"
              />
            </div>
          </div>
          <ul class="menu-list">
            <li
              v-for="(group, key) in filtered_groups"
              :key="key"
              @click="select_group(key)"
            >
              <a :class="{ 'is-active': selected_group == key }">
                <div class="title is-6">{{ JSON.parse(key).program }}</div>
                <div class="subtitle is-6">
                  {{ JSON.parse(key).stage }}
                  <small>[{{ group.length }}]</small>
                </div>
              </a>
            </li>
          </ul>
        </aside>
      </div>
      <div class="column">
        <div
          class=""
          v-show="selected_group == key"
          v-for="(group, key) in filtered_groups"
          :key="key"
        >
          <div class="p-3">
            <div class="title is-5">{{ JSON.parse(key).program }}</div>
            <div class="subtitle is-5">
              {{ JSON.parse(key).stage }}
            </div>
          </div>

          <div class="title is-6" :class="{ 'mb-1': assigned_students.length }">
            {{ $t("assigned students") }}
            <small>({{ assigned_students.length }})</small>
          </div>
          <div
            class="field is-grouped is-grouped-multiline p-3"
            v-show="assigned_students && assigned_students.length"
          >
            <div
              class="control"
              v-for="(item, ridx) in assigned_students"
              :key="ridx"
            >
              <div class="tags has-addons">
                <a
                  class="tag is-delete has-text-danger"
                  @click="remove(item)"
                ></a>
                <span class="tag is-dark"
                  >{{ item.student.first_name }}
                  {{ item.student.surname }}</span
                >
                <span class="tag is-warning">{{
                  item.student.id_card_number
                }}</span>
              </div>
            </div>
          </div>

          <div class="buttons are-small is-pulled-right">
            <div class="tag is-dark">
              <span
                class="icon"
                :class="{
                  'has-text-primary': unassigned_students.filter(
                    (s) => s.is_selected
                  ).length,
                }"
                ><i class="fa fa-user"></i
              ></span>
              <span
                >{{ unassigned_students.filter((s) => s.is_selected).length }}
              </span>
            </div>
            <div class="button is-warning" @click="select_all">
              <span class="icon" :data-tooltip="$t('select all')"
                ><i class="fa fa-check"></i
              ></span>
            </div>
            <div
              class="button"
              :class="{
                'is-info': unassigned_students.filter((s) => s.is_selected)
                  .length,
              }"
              @click="assign_to_section(key)"
            >
              <span class="icon" :data-tooltip="$t('assign to section')"
                ><i class="fa fa-book"></i
              ></span>
            </div>
            <div
              class="button"
              :class="{
                'is-primary': unassigned_students.filter((s) => s.is_selected)
                  .length,
              }"
              @click="divide_sections"
            >
              <span class="icon" :data-tooltip="$t('create sections')"
                ><i class="fa fa-bolt"></i
              ></span>
            </div>
          </div>

          <div
            class="title is-6"
            :class="{ 'mb-1': unassigned_students.length }"
          >
            {{ $t("unassigned students") }}
            <small>({{ unassigned_students.length }})</small>
          </div>
          <div
            class="field is-grouped is-grouped-multiline p-3"
            v-show="unassigned_students && unassigned_students.length"
          >
            <div
              class="control"
              v-for="(item, ridx) in unassigned_students"
              :key="ridx"
            >
              <div class="tags has-addons">
                <a
                  class="tag is-delete has-text-danger"
                  @click="remove(item)"
                ></a>
                <span class="tag is-dark"
                  >{{ item.student.first_name }}
                  {{ item.student.surname }}</span
                >
                <a class="tag has-text-primary">
                  <input type="checkbox" v-model="item.is_selected" />
                </a>
              </div>
            </div>
          </div>

          <div v-if="chunks.length">
            <div class="title is-4 mb-2">{{ $t("sections") }}</div>
            <div class="columns is-multiline">
              <div class="column" v-for="(section, sidx) in chunks" :key="sidx">
                <student-section
                  :students="section"
                  :group="JSON.parse(key)"
                  :period_id="period_id"
                />
              </div>
            </div>
          </div>
          <div class="columns mt-6">
            <div
              class="column is-half"
              v-for="(section, sidx) in inscription_groups"
              :key="sidx"
            >
              <!-- <pre>{{ section }}</pre> -->
              <div class="box">
                <div class="title is-5">
                  {{ section.name }}
                  <small>({{ section.student_section_details.length }})</small>
                  <div
                    class="button is-small is-danger is-pulled-right"
                    @click="remove_group(section)"
                  >
                    <span class="icon"><i class="fa fa-trash"></i></span>
                  </div>
                </div>
                <!-- <div class="title is-5">{{ $t("student list") }}</div> -->
                <table class="table">
                  <thead>
                    <tr>
                      <th>
                        {{ $t("student") }}
                      </th>
                      <th>{{ $t("id") }}</th>
                      <th>{{ $t("options") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(itm, didx) in section.student_section_details"
                      :key="didx"
                    >
                      <td>
                        <span>{{
                          `${itm.inscription.student.first_name} ${itm.inscription.student.surname}`
                        }}</span>
                      </td>
                      <td>{{ itm.inscription.student.id_card_number }}</td>
                      <td>
                        <div
                          class="button is-small has-text-danger"
                          @click="remove_group_item(itm)"
                        >
                          <span class="icon"><i class="fa fa-trash"></i></span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- <button
                  class="button is-primary"
                  :disabled="is_form_invalid"
                  @click="save"
                >
                  <span class="icon"><i class="fa fa-save"></i></span>
                  <span>{{ $t("save") }}</span>
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section-assign-modal
    ref="section_assign_modal"
    @success="select_group(selected_group)"
  />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  error_message,
  format_currency,
  input_alert,
} from "@/utils";
import SectionAssignModal from "./section_assign_modal/Index.vue";
import StudentSection from "./section/Index.vue";
import { groupBy, chunk } from "lodash";

export default {
  name: "InscriptionsDatatable",
  components: {
    GenericTable,
    SectionAssignModal,
    StudentSection,
    GenericDropdown,
  },
  data() {
    2;
    let v = this;
    return {
      inscriptions: [],
      search_group: "",
      selected_group: "",
      section_number: 2,
      chunks: [],
      period_uuid: "",
      period_id: "",
      inscription_list: [],
      inscription_groups: [],
    };
  },
  computed: {
    groups() {
      let v = this;
      return groupBy(v.inscriptions, (i) => {
        return JSON.stringify({
          program: i.program.name,
          stage: i.stage.name,
          program_id: i.program.program_id,
          stage_id: i.stage.stage_id,
        });
      });
    },
    filtered_groups() {
      let v = this;
      if (v.search_group) {
        let filtered = {};
        for (let i in v.groups) {
          let key = JSON.parse(i);
          if (
            key.program.toLowerCase().includes(v.search_group.toLowerCase()) ||
            key.stage.toLowerCase().includes(v.search_group.toLowerCase())
          ) {
            filtered[i] = v.groups[i];
          }
        }
        // console.log("filtered", filtered);
        return filtered;
        // return Object.entries(v.groups).filter((i) => {
        //   console.log(i);
        //   let key = JSON.parse(i[0]);
        //   return (
        //     key.program.toLowerCase().includes(v.search_group.toLowerCase()) ||
        //     key.stage.toLowerCase().includes(v.search_group.toLowerCase())
        //   );
        // });
      }
      return v.groups;
    },
    assigned_students() {
      let v = this;
      if (v.inscription_list && v.inscription_list.length)
        return v.inscription_list.filter((i) => i.exists_in_some_group);
      return [];
    },
    unassigned_students() {
      let v = this;
      if (v.inscription_list && v.inscription_list.length)
        return v.inscription_list.filter((i) => !i.exists_in_some_group);
      return [];
    },
  },
  methods: {
    refresh() {
      let v = this;
      get("/student/inscription/all", { period_uuid: v.period_uuid })
        .then((response) => {
          v.inscriptions = response.map((i) => {
            // let first_pensum = i.program.student_pensums.find((x) => x);
            // if (first_pensum) {
            //   i.courses = first_pensum.student_pensum_courses.map((c) => {
            //     return c.course.name;
            //   });
            // } else i.error = "no pensum found";
            // delete i.program.student_pensums;
            return i;
          });
        })
        .catch((error) => {
          error_message(error);
        });
    },
    select_group(key) {
      let v = this;
      v.selected_group = key;
      v.chunks = [];
      get("/student/inscription/all/detail", {
        period_id: v.period_id,
        program_id: JSON.parse(key).program_id,
        stage_id: JSON.parse(key).stage_id,
      })
        .then((response) => {
          v.inscription_list = response.inscriptions.map((i) => {
            i.exists_in_some_group = response.groups.some((g) => {
              return g.student_section_details.some((d) => {
                return d.inscription_id == i.inscription_id;
              });
            });
            return i;
          });
          v.inscription_groups = response.groups;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete inscription?"),
        v,
        () => {
          del("/student/inscription", { uuid: item.uuid })
            .then(() => {
              v.select_group(v.selected_group);
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    divide_sections() {
      let v = this;
      let options = {
        input: "text",
        title: v.$t("enter maximum students per section"),
        text: v.$t(
          "this will take all of the unassigned students and make them into sections of the specified size"
        ),
        placeholder: "40",
        confirm_text: v.$t("save"),
        cancel_text: v.$t("cancel"),
      };
      input_alert(options).then((value) => {
        try {
          let size = Number(value);
          let chnks = chunk(
            v.unassigned_students.filter((i) => i.is_selected),
            size
          );
          v.chunks = chnks;
        } catch (error) {
          error_message(error);
        }
      });
    },
    set_period(period) {
      let v = this;
      if (period) {
        v.period_uuid = period.uuid;
        v.period_id = period.period_id;
        v.refresh();
      }
    },
    remove_group(group) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete section?"),
        v,
        () => {
          del("/student/section", { uuid: group.uuid })
            .then(() => {
              v.select_group(v.selected_group);
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    remove_group_item(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete student from section?"),
        v,
        () => {
          del("/student/section/student", { uuid: item.uuid })
            .then(() => {
              v.select_group(v.selected_group);
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    select_all() {
      let v = this;
      v.unassigned_students.forEach((i) => {
        i.is_selected = true;
      });
    },
    assign_to_section(key) {
      let v = this;
      let selected_students = v.unassigned_students.filter(
        (i) => i.is_selected
      );
      if (selected_students.length) {
        v.$refs.section_assign_modal.show_modal(selected_students, key);
      }
    },
  },
  mounted() {
    // this.refresh();
  },
};
</script>

<style></style>
